import {AfterViewInit, Component, Input, OnInit, QueryList, ViewChild, ViewChildren} from "@angular/core";
import {DetailConfigurationField} from "../../../../models/detail-configuration-field";
import {NgForm} from "@angular/forms";
import {ReloadComponent} from "../reload/reload.component";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {Observable, forkJoin} from "rxjs";
import {HelperService} from "../../../../services/helperService";
import {ToastrService} from "ngx-toastr";
import {Field} from "../field";
import {TranslateService} from "@ngx-translate/core";


@Component({
	selector: "tig-form-component",
	templateUrl: "./form.component.html"
})
export class FormComponent implements OnInit, AfterViewInit
{


	/**
	 * Attributes
	 */
	@Input() OBJ_assignment;
	@Input() OBJ_config_fields: DetailConfigurationField;

	// Contains all components that extend from ReloadComponent
	@ViewChildren(ReloadComponent) ARR_components_external_data: QueryList<ReloadComponent>;
	@ViewChildren(Field) ARR_form_fields: QueryList<Field>;

	OBJ_assignment_config: DetailConfigurationField;
	public STR_value;


	/**
	 * Function > constructor
	 * @param {Ng4LoadingSpinnerService} OBJ_loading_spinner
	 * @param {HelperService} OBJ_helper_service
	 * @param {ToastrService} OBJ_toastr_service
	 * @param {TranslateService} OBJ_translate_service
	 */
	constructor(
		private OBJ_loading_spinner: Ng4LoadingSpinnerService,
		private OBJ_helper_service: HelperService,
		private OBJ_toastr_service: ToastrService,
		private OBJ_translate_service: TranslateService
	) {} // end function constructor


	/**
	 * Function > ngOnInit
	 */
	ngOnInit()
	{

		// nested assignments: get assignments
		this.OBJ_assignment_config = this.findConfigFieldByName("assignments");

		for (let OBJ_field of this.OBJ_config_fields.fields)
		{

			let ARR_name = OBJ_field.name.split('.');
			if (ARR_name.length)
			{

				this.STR_value = this.OBJ_assignment;
				for (let STR_part of ARR_name)
				{
					this.STR_value = this.STR_value[STR_part];
				} // end for

			} // end if

		} // end for

	} // end function ngOnInit


	/**
	 * Function > ngAfterViewInit
	 */
	ngAfterViewInit(): void
	{

		// there are components which need data from the backend
		if (this.ARR_components_external_data.length > 0)
		{

			// show user that we are doing sth.
			this.OBJ_loading_spinner.show();
			let ARR_observables: Observable<void>[] = [];

			// get all data from backend
			this.ARR_components_external_data.forEach(OBJ_component =>
			{
				ARR_observables.push(OBJ_component.OBJ_observable_external_data);
			});

			// Reload all data from backend and show form if all went well
			forkJoin(ARR_observables).subscribe(
				result =>
				{
				},
				error =>
				{
					this.OBJ_helper_service.error({
						class: "FormComponent",
						function: "ngAfterViewInit"
					}, error);
					this.OBJ_toastr_service.error(this.OBJ_translate_service.instant("oError.sLoadingData"));
					this.OBJ_loading_spinner.hide();
				},
				() =>
				{
					this.OBJ_loading_spinner.hide();
				} // end subsribe
			);

		} // end if

	} // end ngAfterViewInit


	/**
	 * Function > findConfigFieldByName
	 * @param STR_name
	 * @return {DetailConfigurationField}
	 */
	findConfigFieldByName(STR_name): DetailConfigurationField
	{
		return this.OBJ_config_fields.fields.find(OBJ_config_entry => OBJ_config_entry.name === STR_name);
	} // end function findConfigFieldByName


	/**
	 * Function > findAssignmentByTitle
	 * @param STR_name
	 * @return {T}
	 */
	findAssignmentByTitle(STR_name): {T}
	{
		return this.OBJ_assignment.assignments.find(OBJ_assignment => OBJ_assignment.title === STR_name);
	} // end function findAssignmentByTitle


	/**
	 * Function > isInvalid
	 * @return {boolean}
	 */
	isInvalid(): boolean
	{
		let BOO_invalid = false;

		// get all data from backend
		this.ARR_form_fields.forEach(OBJ_component =>
		{
			BOO_invalid = BOO_invalid || OBJ_component.isInvalid();
		});

		return BOO_invalid;

	} // end function isInvalid


} // end class FormComponent
